import XeroMixin from './xeroMixin';
import QuickbooksMixin from './quickbooksMixin';
import { mapGetters } from 'vuex';

export default {
  mixins: [
    XeroMixin,
    QuickbooksMixin,

  ],
  computed: {
    ...mapGetters('companies', {
      company: 'currentCompany',
    }),

  },
  methods: {
    isConnectedToOnlineInvoicing(company) {
      return company && company.id && (this.isQuickbooksConnected(company) || this.isXeroConnected(company));
    },

  },
};



// WEBPACK FOOTER //
// ./src/mixins/invoicingMixin.js